import React from 'react';
/**
 * Highlights matching text within a string by wrapping matched portions in <strong> tags.
 * Matching is case-insensitive, but the original casing is preserved in the output.
 * @param {string} text - The full text to display
 * @param {string} filter - The term to highlight (case-insensitive matching)
 * @returns {React.ReactNode} - Text with matched portions wrapped in <strong> tags,
 *                              or the original text if no filter is provided
 * @example
 * // Returns: [<strong key="0">Sun</strong>, 'shine Apartments']
 * getHighlightedText('Sunshine Apartments', 'sun');
 *
 * // Returns: [<strong key="0">sun</strong>, 'flower ', <strong key="2">Sun</strong>, 'day']
 * getHighlightedText('sunflower Sunday', 'sun');
 *
 * // Returns: 'Sunshine Apartments' (no highlighting when filter is empty)
 * getHighlightedText('Sunshine Apartments', '');
 */
export function getHighlightedText(text, filter) {
  if (!filter || !text) {
    return text;
  }
  // Escape special regex characters in search term
  const escapedSearchTerm = filter.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
  const parts = text.split(regex);
  // If no match found, return original text
  if (parts.length === 1) {
    return text;
  }
  return parts.map((part, index) => {
    if (part.toLowerCase() === filter.toLowerCase()) {
      // eslint-disable-next-line react/no-array-index-key
      return <strong key={`${index}-${part}`}>{part}</strong>;
    }
    return part;
  });
}
export default getHighlightedText;
